import React from 'react';
import { useField } from 'formik';

interface Props {
  name: string;
  onBlur?: React.FocusEventHandler<HTMLElement>;
  onChange?: React.ChangeEventHandler<HTMLElement>;
  onFocus?: React.FocusEventHandler<HTMLElement>;
}

export const useFormInput = ({ name, onBlur, onChange, onFocus }: Props) => {
  const [field, fieldMeta, helpers] = useField(name);
  const hasError = fieldMeta.touched && !!fieldMeta.error;

  const handleBlur = (e: React.FocusEvent<HTMLElement>) => {
    helpers.setTouched(true);
    field.onBlur(e);
    onBlur && onBlur(e);
  };

  const handleChange = (e: React.ChangeEvent<HTMLElement>) => {
    field.onChange(e);
    onChange && onChange(e);
  };

  const handleFocus = (e: React.FocusEvent<HTMLElement>) => {
    !fieldMeta.touched && helpers.setTouched(true);
    onFocus && onFocus(e);
  };

  return {
    ...fieldMeta,
    ...field,
    ...helpers,
    hasError,
    handleBlur,
    handleChange,
    handleFocus,
  };
};
